import React from "react";
import { Button } from "@/components/ui/button";
import { Robot, CircleNotch } from "@phosphor-icons/react";

export const AiCategorizeBar = ({ s, onRun, onRunAll, busy }) => (
  <div className="rounded-sm border border-slate-800 bg-slate-900/50 px-4 py-3 flex flex-wrap items-center gap-3" data-testid="ai-cat-bar">
    <Robot size={18} className="text-orange-400" />
    <div className="text-xs text-slate-300 flex flex-wrap gap-x-3 gap-y-1">
      <span data-testid="ai-cat-done">AI category: {s.done} / {s.ready_total}</span>
      {s.queued > 0 && <span className="text-orange-300 flex items-center gap-1" data-testid="ai-cat-queued"><CircleNotch size={12} className="animate-spin" /> {s.queued} line me</span>}
      {s.failed > 0 && <span className="text-red-300">Fail: {s.failed}</span>}
      <span className="text-amber-300" data-testid="ai-cat-review">Review: {s.review}</span>
      <span>Pakke examples: {s.locked}</span>
    </div>
    <Button size="sm" disabled={busy || s.queued > 0 || s.done >= s.ready_total} onClick={onRun}
      className="ml-auto rounded-sm bg-orange-500 hover:bg-orange-600 text-white" data-testid="ai-cat-run">
      AGLE 100 KO AI CATEGORY DO
    </Button>
    <Button size="sm" disabled={busy || s.queued > 0 || s.done >= s.ready_total} onClick={onRunAll}
      className="rounded-sm bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="ai-cat-run-all">
      BAAKI SAB KO AI CATEGORY DO
    </Button>
  </div>
);
